import React, { useState } from "react";
import {
  STAccordion,
  STButton,
  STDrawer,
  STHeroCommon,
  STProgressBar,
  STSwiper,
} from "..";
import styles from "./STAboutUs.module.css";
import clsx from "clsx";
import {
  faqData,
  ourApproachData,
  processSteps,
  researchMissionfeatures,
  specializationItems,
  teamData,
  testimonialsData,
} from "@/const/data";
import { Icons } from "@/const/icons";
import Image from "next/image";
import {
  ourInnovationImg,
  ourLaboratoryImg,
  rightArrow,
} from "@/assets/images";
import { SwiperSlide } from "swiper/react";
import Link from "next/link";
import { useRouter } from "next/router";

export const STAboutUs = () => {
  const [bioMaterialDrawerOpen, setBioMaterialDrawerOpen] = useState(false);
  const router = useRouter();

  return (
    <>
      <STHeroCommon
        title={"About us"}
        description={
          "We are building the next generation of green-materials that help industries move beyond fossil-based plastics-without compromising performance, scale, or economics."
        }
      />

      {/* RESEARCH MISSION SECTION START  */}
      <section className={clsx(styles.researchMissionSection, "space-xl-py")}>
        <div className="container">
          <div
            className={clsx(
              styles.researchMissionWrapper,
              "d-flex flex-column flex-xl-row gap-lg",
            )}
          >
            <div className={clsx(clsx(styles.researchMissionContent, "w-100"))}>
              <h2 className="primary-title text-clr-gray mb-0">
                Advanced bio-materials{" "}
                <span className="primary-title mb-0">
                  {" "}
                  for transitioning to the circular economy
                </span>
              </h2>

              <p className="paragraph-text space-sm-mt space-md-mb">
                We believe that transitioning to green technologies should not come with a green-premium. Our bio-coating system is the first amongst many products that we intend to develop, with this same principle.
              </p>
              <STButton
                suffix={Icons.arrowDoubleRightIcon}
                variant="outline-primary"
                onClick={() => setBioMaterialDrawerOpen(true)}
              >
                Learn more
              </STButton>
            </div>

            <div
              className={clsx(
                styles.researchMissionfeaturesWrap,
                "d-grid gap-sm flex-shrink-0 w-100",
              )}
            >
              {researchMissionfeatures.map((item, index) => (
                <div
                  key={index}
                  className={clsx(
                    styles.card,
                    "bg-off-white space-md-p radius-lg",
                  )}
                >
                  <Image
                    src={item.icon}
                    alt=""
                    width={72}
                    height={72}
                    className={styles.researchMissionfeatureIcon}
                  />
                  <p className={"secondary-title mb-0 h5 space-md-mt"}>
                    {item.title}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* RESEARCH MISSION SECTION END  */}

      {/* OUR APPROACH SECTION START */}
      <section className={clsx(styles.ourApproachSection, "space-lg-pt")}>
        <div className="container">
          <div
            className={clsx(
              styles.ourApproachheader,
              "d-flex flex-column align-items-center space-lg-mb",
            )}
          >
            <h2 className="primary-title text-clr-white mb-0">
              Our approach :
            </h2>
            <h2 className="primary-title text-clr-gray-55 mb-0">
              Science and economy should go hand-in-hand
            </h2>
          </div>

          <div
            className={clsx(styles.ourApproachcardsWrapper, "d-grid gap-md")}
          >
            {ourApproachData.map((item, index) => (
              <div
                key={index}
                className={clsx(
                  styles.ourApproachcard,
                  "bg-off-white position-relative radius-lg space-md-p cursor-pointer transition-smooth",
                )}
              >
                <span
                  className={clsx(
                    styles.ourApproachIcon,
                    "space-lg-mb d-block transition-smooth",
                  )}
                >
                  {item.icon}
                </span>
                <h3 className="fw-normal mb-2 transition-smooth">
                  {item.title}
                </h3>
                <p className={clsx("paragraph-text transition-smooth mb-0")}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* OUR APPROACH SECTION END */}

      {/* OUR INNOVATION SECTION START */}
      {/* <section className="space-xl-py">
        <div className="container">
          <div className="bg-off-white radius-xl space-sm-p">
            <div
              className={clsx(
                styles.ourInnovationHeading,
                "d-flex flex-column flex-sm-row justify-content-between align-items-start gap-sm",
              )}
            >
              <div>
                <h2 className="primary-title mb-0">Our innovation...</h2>
                <h2 className="primary-title text-clr-gray mb-0">
                  What make our laboratory truly stand apart
                </h2>
              </div>
              <div
                className={clsx(
                  styles.reviewBadge,
                  "d-flex align-items-center gap-3 bg-white flex-shrink-0",
                )}
              >
                {Icons.starIcon}
                <p className={clsx("h6 big mb-0")}>27k Reviews</p>
              </div>
            </div>
            <div className={clsx("d-flex gap-sm flex-column flex-lg-row")}>
              <div
                className={clsx(
                  styles.ourInnovationImageWrapper,
                  "w-100 ratio radius-md overflow-hidden",
                )}
              >
                <Image
                  src={ourInnovationImg}
                  alt="our innovation "
                  className="object-fit-cover"
                />
              </div>
              <div
                className={clsx(
                  styles.ourInnovationContent,
                  "w-100 bg-white radius-md space-md-p",
                )}
              >
                <p className="paragraph-text space-md-mb">
                  we stand out through our dedication to excellence, innovation,
                  and scientific integrity. Our lab brings together cutting-edge
                  technology,
                </p>

                <div className="space-lg-mb">
                  <h4 className="secondary-title space-sm-mb">Data accuracy</h4>
                  <STProgressBar value={75} />
                </div>
                <div>
                  <h4 className="secondary-title space-sm-mb">
                    Experimental reliability
                  </h4>
                  <STProgressBar value={85} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* OUR INNOVATION SECTION END */}

      {/* OUR PROCESS SECTION START */}
      <section className="space-xl-py">
        <div className="container">
          <div className="text-center space-lg-mb">
            <h2 className="primary-title mb-0">Our strength...</h2>
            <h2 className="primary-title text-clr-gray mb-0">
              Materials we develop are closely aligned  with the industry from day one
            </h2>
            <p
              className={clsx(
                styles.ourProcessDescription,
                "paragraph-text space-sm-mt mx-auto mb-0",
              )}
            >
              We have all the synthesis, analytical and characterization equipment, demo-plant  in-house hence it gives us better control on research and scaling. We collaborate with our partners from industrial trials for accurate results.
            </p>
          </div>

          <div className={clsx(styles.processSteps, "d-grid")}>
            {processSteps.map((step, index) => (
              <div
                key={step.id}
                className={clsx(
                  styles.stepWrapper,
                  "d-flex flex-column justify-content-center align-items-center position-relative text-center",
                )}
              >
                <div
                  className={clsx(
                    styles.step,
                    "rounded-circle d-flex justify-content-center align-items-center space-md-mb",
                  )}
                  style={{ background: `rgb(${step.bg},0.1)` }}
                >
                  <div
                    className={styles.icon}
                    style={{ color: `rgb(${step.bg},1)` }}
                  >
                    {step.icon}
                  </div>
                </div>

                <h3 className={"mb-2 fw-normal h4"}>{step.title}</h3>
                <p className={"paragraph-text mb-0"}>{step.description}</p>

                {/* Arrow */}
                {index < processSteps.length - 1 && (
                  <div
                    className={clsx(styles.processArrow, "d-none d-xl-block")}
                  >
                    <Image
                      src={rightArrow}
                      alt="arrow"
                      className="w-100 h-100"
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* OUR PROCESS SECTION END */}

      {/* OUR LABORATORY SECTION START */}
      <section className={clsx(styles.ourLaboratorySection, "")}>
        <div className="container">
          <div className="radius-xl bg-off-white space-sm-p">
            <div
              className={clsx(
                styles.ourLaboratoryHeader,
                "d-flex flex-column flex-sm-row justify-content-between align-items-start gap-xs",
              )}
            >
              <div>
                <h2 className="primary-title mb-0">
                  Our research capabilities...
                </h2>
                <h2 className="primary-title text-clr-gray mb-0">
                  From lab-scale to demo production, all in-house
                </h2>
              </div>
              <STButton
                className={"flex-shrink-0"}
                onClick={() => router.push("/contact-us")}
              >
                Let's talk
              </STButton>
            </div>
            <div
              className={clsx(
                "d-flex gap-sm flex-column flex-lg-row space-sm-mt",
              )}
            >
              <div
                className={clsx(
                  styles.ourLaboratoryContent,
                  " d-flex flex-column gap-sm",
                )}
              >
                <div className="bg-white space-md-p radius-md">
                  <p className="paragraph-text space-md-mb">
                    From a Scanning Electron Microscope to 1, 5 tons Stainless steel reactors, our strength lies in researching and scaling right at our centre in Chemelot, Netherlands for quick turnaround. 
                  </p>
                  <div className="d-flex gap-4 flex-wrap">
                    <div
                      className={clsx(
                        styles.ourLaboratoryTag,
                        "d-flex align-items-center gap-2 bg-off-white radius-xl",
                      )}
                    >
                      {Icons.molecularBiologyIcon}
                      <h3 className="secondary-title mb-0 h5">Chemistry</h3>
                    </div>
                    <div
                      className={clsx(
                        styles.ourLaboratoryTag,
                        "d-flex align-items-center gap-2 bg-off-white radius-xl",
                      )}
                    >
                      {Icons.environmentalIcon}
                      <h3 className="secondary-title mb-0 h5">Biochemistry</h3>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column flex-sm-row gap-sm h-100">
                  <div className="bg-white radius-md space-md-p w-100">
                    <h2
                      className={clsx(
                        styles.ourLaboratoryValue,
                        "text-clr-secret-garden mb-0",
                      )}
                    >
                      25+
                    </h2>
                    <h3 className="secondary-title text-clr-gray mb-0 h5">
                      Equipment types
                    </h3>
                  </div>
                  <div className="bg-white radius-md space-md-p w-100">
                    <h2
                      className={clsx(
                        styles.ourLaboratoryValue,
                        "text-clr-secret-garden mb-0",
                      )}
                    >
                      ~15
                    </h2>
                    <h3 className="secondary-title text-clr-gray mb-0 h5">
                      tons production capability
                    </h3>
                  </div>
                </div>
              </div>
              <div
                className={clsx(
                  styles.ourLaboratoryImageWrapper,
                  "w-100 ratio radius-md overflow-hidden",
                )}
              >
                <Image
                  src={ourLaboratoryImg}
                  alt="our laboratory "
                  className="object-fit-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* OUR LABORATORY SECTION END */}

      {/* TESTIMONIALS SECTION START */}
      {/* <section className="space-xl-py bg-clr-black">
        <div className="container space-lg-mb">
          <div className="d-flex flex-column flex-sm-row gap-sm justify-content-between align-items-start">
            <div>
              <h2 className="primary-title text-clr-gray-55 mb-0">
                Testimonials that reflect our
              </h2>
              <h2 className="primary-title text-white mb-0">
                scientific commitment
              </h2>
            </div>
            <div className="d-flex align-items-center gap-sm">
              <STButton aria-label="Previous Testimonial" variant="icon" className="testimonial-prev dark">
                {Icons.arrowLeft}
              </STButton>
              <STButton aria-label="Next Testimonial" variant="icon" className="testimonial-next dark">
                {Icons.arrowRight}
              </STButton>
            </div>
          </div>
        </div>
        <STSwiper
          slidesPerView={3.4}
          prevClass=".testimonial-prev"
          nextClass=".testimonial-next"
          className={styles.testimonialSwiper}
          breakpoints={{
            0: { slidesPerView: 1.2, spaceBetween: 20 },
            768: { slidesPerView: 1.8, spaceBetween: 28 },
            992: { slidesPerView: 2.4, spaceBetween: 32 },
            1200: { slidesPerView: 3.2, spaceBetween: 40 },
            1440: { slidesPerView: 3.4 },
          }}
        >
          {testimonialsData.map((item) => (
            <SwiperSlide key={item.id} className={styles.testimonialSlide}>
              <div
                className={clsx(
                  styles.testimonialCard,
                  "bg-off-white radius-md space-md-p h-100 d-flex gap-lg flex-column justify-content-between align-items-start transition-smooth",
                )}
              >
                <p
                  className={clsx(
                    "h6 big fw-normal lh-base mb-0 transition-smooth",
                  )}
                >
                  {item.quote}
                </p>
                <div>
                  <h5 className="mb-2 fw-normal transition-smooth">
                    - {item.author}
                  </h5>
                  <p
                    className={clsx(
                      styles.autherRoal,
                      "mb-0 text-clr-gray transition-smooth",
                    )}
                  >
                    {item.role}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </STSwiper>
      </section> */}
      {/* TESTIMONIALS SECTION END */}

      {/* OUR TEAM SECTION START */}
      <section className="space-xl-py">
        <div className="container">
          <div
            className={clsx(
              "d-flex justify-content-between align-items-sm-center space-lg-mb gap-xs flex-column flex-sm-row",
            )}
          >
            <div className={clsx(styles.ourTeamTitle)}>
              <h2 className="primary-title mb-0">Our team...</h2>
              <h2 className="primary-title text-clr-gray mb-0">
                The brilliant minds powering our research team
              </h2>
            </div>
            <div className="d-flex align-items-center gap-sm">
              <STButton aria-label="Previous Team Member" variant="icon" className="team-prev">
                {Icons.arrowLeft}
              </STButton>
              <STButton aria-label="Next Team Member" variant="icon" className="team-next">
                {Icons.arrowRight}
              </STButton>
            </div>
          </div>

          <STSwiper
            slidesPerView={4}
            spaceBetween={24}
            prevClass=".team-prev"
            nextClass=".team-next"
            breakpoints={{
              0: { slidesPerView: 1 },
              480: { slidesPerView: 1.8 },
              576: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
          >
            {teamData.map((member, index) => (
              <SwiperSlide key={index}>
                <div
                  key={member.id}
                  className={clsx(
                    styles.teamCard,
                    "d-flex flex-column align-items-center text-center",
                  )}
                >
                  <div
                    className={clsx(
                      styles.memberImageWrapper,
                      "space-sm-mb rounded-circle overflow-hidden ratio ratio-1x1",
                    )}
                  >
                    <Image src={member.image} alt={member.name} />
                  </div>

                  <h3 className={"h4 mb-2 fw-normal"}>{member.name}</h3>
                  <p className={"h6 big mb-0 fw-normal text-clr-gray"}>
                    {member.role}
                  </p>

                  <div
                    className={clsx(styles.socials, "space-xs-mt d-flex gap-3")}
                  >
                    {member.socials.map((social, index) => {
                      return (
                        <Link
                          key={index}
                          href={social.url}
                          target="_blank"
                          className={clsx(
                            styles.socialIcon,
                            styles[social.type],
                            "bg-off-white rounded-circle d-flex justify-content-center align-items-center",
                          )}
                          aria-label={social.type}
                        >
                          {social.icon}
                        </Link>
                      );
                    })}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </STSwiper>
        </div>
      </section>
      {/* OUR TEAM SECTION END */}

      {/* OUR SPECIALIZATION STACTION START */}
      <section className={clsx(styles.ourSpecializationSection, "space-xl-py")}>
        <div className="container">
          <div className="text-center space-lg-mb">
            <h2 className="primary-title text-clr-white mb-0">
              Our specialization...
            </h2>
            <h2 className="primary-title text-clr-gray-55 mb-0">
              Explore our specialized areas of scientific expertise
            </h2>
          </div>
          <div
            className={clsx(styles.specializationCardWrapper, "d-grid gap-md")}
          >
            {specializationItems.map((item) => {
              if (item.type === "image") {
                return (
                  <div
                    key={item.id}
                    className={clsx(
                      styles.specializationImgWrapper,
                      "position-relative radius-lg overflow-hidden ratio",
                    )}
                  >
                    <Image
                      src={item.image}
                      alt={item.alt}
                      fill
                      className={"object-fit-cover"}
                    />
                  </div>
                );
              }

              return (
                <div
                  key={item.id}
                  className={clsx(
                    styles.specializationCard,
                    "bg-off-white radius-lg space-md-p",
                  )}
                >
                  <h3 className={"fw-normal space-md-mb h4"}>{item.title}</h3>
                  <p className={"paragraph-text mb-0"}>{item.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      {/* OUR SPECIALIZATION STACTION END */}

      {/* Bio Material Drawer Start */}
      <STDrawer
        open={bioMaterialDrawerOpen}
        onClose={() => setBioMaterialDrawerOpen(false)}
        title="Advanced bio-materials for transitioning to the circular economy"
      >
        <p className="paragraph-text mb-0">
          We believe that transitioning to green technologies should not come with a green-premium. Our bio-coating system is the first amongst many products that we intend to develop, with this same principle.
        </p>
      </STDrawer>
      {/* Bio Material Drawer End */}
    </>
  );
};
